import { render, staticRenderFns } from "./ProtocolSession.vue?vue&type=template&id=5d9e8bd7&"
import script from "./ProtocolSession.vue?vue&type=script&lang=js&"
export * from "./ProtocolSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports